import React, { FC } from "react";
import { startCase } from "lodash";
import { CopyButton as CopyBtn } from "../../../../components/fields/CopyButton/CopyButton";

interface Props {
  text: string;
  value: string;
}

export const CopyButton: FC<Props> = ({ text, value }) => (
  <CopyBtn
    text={`Copy ${startCase(text)}`}
    value={value}
    variant="outlined"
    color="primary"
    style={{ marginBottom: "20px" }}
  />
);
